(function (root) {
  'use strict';
  var config = null;
  var interval = null;
  function readConfig() {
    if (config) return config;
    if (typeof document === 'undefined') return null;
    var node = document.getElementById('MSSServiceConfig');
    if (!node) return null;
    try { config = JSON.parse(node.textContent); } catch (error) { return null; }
    return config;
  }
  function text(key) {
    var settings = readConfig();
    return settings && settings.strings ? settings.strings[key] || '' : '';
  }
  function responseAt(now, settings) {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: settings.timeZone, weekday: 'short', hour: 'numeric', hourCycle: 'h23'
    }).formatToParts(now);
    var values = {};
    parts.forEach(function (part) { values[part.type] = part.value; });
    var hour = Number(values.hour);
    var business = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].indexOf(values.weekday) !== -1 &&
      hour >= Number(settings.opens) && hour < Number(settings.closes);
    var minutes = Number(business ? settings.businessMinutes : settings.afterHoursMinutes);
    if (!Number.isFinite(minutes) || minutes <= 0) throw new Error('Invalid response target');
    return { business: business, minutes: minutes, replyBy: new Date(now.getTime() + minutes * 60000) };
  }
  function update(node, now) {
    var settings = readConfig();
    if (!settings || !settings.enabled) { node.hidden = true; return; }
    try {
      var result = responseAt(now || new Date(), settings);
      var label = result.minutes >= 60 && result.minutes % 60 === 0
        ? text('withinHours').replace('[hours]', String(result.minutes / 60))
        : text('withinMinutes').replace('[minutes]', String(result.minutes));
      var replyTime = new Intl.DateTimeFormat('en-US', {
        timeZone: settings.timeZone, weekday: 'short', hour: 'numeric', minute: '2-digit', timeZoneName: 'short'
      }).format(result.replyBy);
      node.querySelector('[data-mss-response-target]').textContent = label;
      var deadline = node.querySelector('[data-mss-response-deadline]');
      deadline.textContent = text('replyBy').replace('[time]', replyTime);
      deadline.hidden = false;
      node.dataset.responsePeriod = result.business ? 'business' : 'after-hours';
      node.hidden = false;
    } catch (error) { /* Keep the translated business/after-hours fallback. */ }
  }
  function refresh() {
    document.querySelectorAll('[data-mss-response-time]').forEach(function (node) { update(node); });
  }
  function createResponse() {
    var settings = readConfig();
    if (!settings || !settings.enabled) return null;
    var box = document.createElement('div');
    box.className = 'mss-response-time mss-response-time--compact';
    box.setAttribute('data-mss-response-time', '');
    var label = document.createElement('span');
    label.className = 'mss-response-label'; label.textContent = text('responseLabel');
    var target = document.createElement('strong'); target.setAttribute('data-mss-response-target', '');
    var deadline = document.createElement('span'); deadline.className = 'mss-response-deadline';
    deadline.setAttribute('data-mss-response-deadline', '');
    box.appendChild(label); box.appendChild(target); box.appendChild(deadline);
    update(box);
    return box;
  }
  function updateStock(container, available, quantity, tracked) {
    var badge = container.querySelector('[data-mss-stock-badge]');
    if (!badge) return;
    var state = available && Number(quantity) > 0 ? 'in-stock' : available && !tracked ? 'order' : 'check';
    badge.dataset.state = state;
    badge.querySelector('[data-mss-stock-label]').textContent = text(state === 'in-stock' ? 'inStock' : state === 'order' ? 'availableOrder' : 'checkAvailability');
  }
  function init() {
    refresh();
    if (!interval) interval = root.setInterval(refresh, 60000);
  }
  var api = { responseAt: responseAt, createResponse: createResponse, text: text, updateStock: updateStock, refresh: refresh };
  root.MSSServiceStatus = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', refresh);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });
  }
})(typeof window !== 'undefined' ? window : globalThis);
